import { assign } from 'lodash'

export default function(user) {
  return assign({}, user, {
    fullName: user.fullName || user.name,
  })
}


// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/users/shared/parseUser.js